// extracted by mini-css-extract-plugin
export default {"container":"Y3CUTnwj2Vi3LqZh_cG4","page":"BaSrI4VnRzeUMjAOQw4J","progress":"hmVhi_yI0aIjZRTkTqUT","page-loader":"G0XNxWN_mSS0xmXt4puy","pageLoader":"G0XNxWN_mSS0xmXt4puy"};